import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams, HttpParamsOptions} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {ShipmentDetails} from "../../../models/shipments-models/shipment.model";

@Injectable({
  providedIn: 'root'
})
export class BudgetsService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8',
    }),
  };

  constructor(public http: HttpClient) { }

  getBudgets(startDate: any, endDate: any) {
    let url = this.BASE_URL + "budgets/list";
    if (startDate && endDate) {
      url = url + "?startDate=" + startDate + "&endDate=" + endDate;
    }
    return this.http.get(url, this.OPTIONS);
  }

  getBudgetDetails(budgetUuid: any) {
    let url = this.BASE_URL + "budgets/details";
    if (budgetUuid) {
      url = url + "?budgetUuid=" + budgetUuid;
    }
    return this.http.get(url, this.OPTIONS);
  }

  sendBudgetResponse(body: { uuid: string; accept: boolean; paymentMode?: string; paymentReceiptFile?: any; orderDocumentFile?: any; paypalOrderId?: string }) {
    const url = this.BASE_URL + "budgets/sendResponse";
    return this.http.patch(url, body, this.OPTIONS);
  }

  createPaypalOrder(body: { uuid: string }) {
    const url = this.BASE_URL + 'budgets/createPaypalOrder';
    return this.http.patch(url, body, this.OPTIONS);
  }

  capturePaypalOrder(body: { budgetUuid: string; paypalOrderId: string }) {
    const url = this.BASE_URL + 'budgets/capturePaypalOrder';
    return this.http.patch(url, body, this.OPTIONS);
  }

  getPaymentModes(companyUuid: string) {
    const url = this.BASE_URL + 'commonLists/companies/paymentModes?companyUuid=' + companyUuid;
    return this.http.get(url, this.OPTIONS);
  }

  getBudgetsCounters() {
    const url = this.BASE_URL + 'budgets/counters';
    return this.http.get(url, this.OPTIONS);
  }
 
}
